// extracted by mini-css-extract-plugin
export var statItem = "_it-1";
export var statsRow = "_it-0";